import api from './apiService'; // Authenticated Axios instance (attaches the Bearer token)

// Health commission registration no. + logo shown on reports. The API takes
// the lab from the JWT. See docs/features/health-commission/spec.md.
const BASE = 'HealthCommission';

// Report templates read this cache (Templates/fontStyle.js readHealthCommission),
// the same way they read DoctorInfo.
export const cacheHealthCommission = (data) => {
  try {
    if (data?.registrationNo || data?.logo) {
      localStorage.setItem('HealthCommission', JSON.stringify(data));
    } else {
      localStorage.removeItem('HealthCommission');
    }
  } catch (e) {
    // Storage full or blocked - reports just won't show it.
    console.error('Failed to cache health commission settings', e);
  }
};

export const healthCommissionService = {
  get: async () => {
    const response = await api.get(BASE);
    return response.data;
  },
  // file: optional new logo File; removeLogo: true to clear the saved logo.
  save: async (registrationNo, file, removeLogo = false) => {
    const form = new FormData();
    form.append('registrationNo', registrationNo || '');
    form.append('removeLogo', removeLogo ? 'true' : 'false');
    if (file) form.append('logo', file);
    const response = await api.put(BASE, form);
    return response.data;
  }
};
